/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";

export default function Contact() {
    const { t } = useTranslation();
    useScrollAnimation();
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Contact Us")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("Contact Us")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[30px]">
                    <div className="btmAni25002 text-[25px] font-bold text-center capitalize">{t("Get In Touch With Us")}</div>
                    <div className="f-col flex">
                        <div className="btmAni20002 w-100 w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/phone-icon.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">{t("Call Now")}</span>
                                <Link to={"tel:+962 79 255 5592"}>+962 79 255 5592</Link>
                            </div>
                        </div>
                        <div className="btmAni3000 w-100 w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/location-icon.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">{t("Location")}</span>
                                <Link to={"https://www.google.com/maps/dir/?api=1&destination=31.9038%2C35.8467"}>{t("Marj al hamam, Amman, Jordan")}</Link>
                            </div>
                        </div>
                        <div className="btmAni2500 w-100 w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/email-icon.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">{t("Email")}</span>
                                <Link to={"mailto:info@alnujoud-jo.com"}>info@alnujoud-jo.com</Link>
                            </div>
                        </div>
                        <div className="btmAni30002 w-100 w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/work-icon.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">{t("working hours")}</span>
                                <Link className="flex flex-col text-center gap-[4px]" to={""}>
                                    <span>{t("Saturday to Thursday")}</span>
                                    <span>8:30 AM - 4:30 PM</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[30px]">
                    <div className="js-scroll fade-top text-[25px] font-bold text-center capitalize">{t("Talk to us")}</div>
                    <form>
                        <div className="flex flex-col gap-[20px]">
                            <div className="f-col flex justify-between">
                                <div className="w-100 w-[48%] flex flex-col gap-[15px]">
                                    <div className="js-scroll fade-left flex flex-col gap-[8px]">
                                        <label className="border-l-[6px] border-[#017E89] pl-1.5 font-bold text-[18px]">{t("Full Name")}</label>
                                        <input className="p-1.5 pl-2.5 border-l-[6px] border-[#017e89] outline-none bg-[rgba(1,126,137,0.14)]" type="text" placeholder="" />
                                    </div>
                                    <div className="js-scroll fade-left flex flex-col gap-[8px]">
                                        <label className="border-l-[6px] border-[#017E89] pl-1.5 font-bold text-[18px]">{t("Email")}</label>
                                        <input className="p-1.5 pl-2.5 border-l-[6px] border-[#017e89] outline-none bg-[rgba(1,126,137,0.14)]" type="email" placeholder="" />
                                    </div>
                                    <div className="js-scroll fade-left flex flex-col gap-[8px]">
                                        <label className="border-l-[6px] border-[#017E89] pl-1.5 font-bold text-[18px]">{t("Phone Number")}</label>
                                        <input className="p-1.5 pl-2.5 border-l-[6px] border-[#017e89] outline-none bg-[rgba(1,126,137,0.14)]" type="text" placeholder="" />
                                    </div>
                                </div>
                                <div className="w-100 js-scroll fade-right flex flex-col gap-[8px] w-[48%]">
                                    <label className="border-l-[6px] border-[#017E89] pl-1.5 font-bold text-[18px]">{t("Massage")}</label>
                                    <textarea className="h-300 p-1.5 pl-2.5 border-l-[6px] border-[#017e89] outline-none bg-[rgba(1,126,137,0.14)] max-h-[350px] h-full"></textarea>
                                </div>
                            </div>
                            <button className="js-scroll fade-btm w-fit  py-[8px] px-[30px] bg-[#017e89] rounded-[4px] text-white font-bold capitalize" type="submit">{t("send")}</button>
                        </div>
                    </form>
                </div>
            </section>
            <section className="js-scroll fade-btm relative py-[40px]">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d211.69414160956998!2d35.846811857105315!3d31.903709976537623!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151ca693a8b7a311%3A0x3b95e54ccd6ac30b!2sNaltshek%2C%20Amman!5e0!3m2!1sen!2sjo!4v1739177602020!5m2!1sen!2sjo"
                    width="600"
                    height="450"
                    style={{ border: '0' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full"
                ></iframe>
            </section>
        </>
    );
}